import reportTmHotelReconciliationDynamic from '@modules/reports/tmReconciliationDynamic/store';
import reportCustomersActivitiesStore from './reportCustomersActivities';
import reportEventOrderDetails from './reportEventOrderDetails';
import reportOrders from './reportOrders';
import reportFinanceCommission from './reportFinanceCommission';
import reportFinanceCommissionDetails from './reportFinanceCommissionDetails';
import reportTmHotelReconciliation from './reportTmHotelReconciliation';
import reportTmHotelReconciliationHotelOnly from './reportTmHotelReconciliationHotelOnly';
import reportHotelDetails from './reportHotelDetails';
import reportBmtCancellations from './reportBmtCancellations';

const STORE_NAME = 'reports';

export default {
    name: STORE_NAME,
    namespaced: true,
    modules: {
        customerActivities: reportCustomersActivitiesStore,
        eventOrderDetails: reportEventOrderDetails,
        orders: reportOrders,
        financeCommission: reportFinanceCommission,
        tmHotelReconciliation: reportTmHotelReconciliation,
        tmHotelReconciliationHotelOnly: reportTmHotelReconciliationHotelOnly,
        tmHotelReconciliationDynamic: reportTmHotelReconciliationDynamic,
        hotelDetails: reportHotelDetails,
        financeCommissionDetails: reportFinanceCommissionDetails,
        bmtCancellations: reportBmtCancellations,
    },
};
